//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'd2d-dialog',
  props: ['visible', 'mainClass', 'appendToBody'],
  methods: {
    cancelHandler: function cancelHandler() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  },
  watch: {
    visible: function visible() {
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};